
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/live-session/galerien/[slug]",
      function () {
        return require("private-next-pages/live-session/galerien/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/live-session/galerien/[slug]"])
      });
    }
  